import { GetStorage, RemoveStorage } from "../../Utils/Storage";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({
  path,
  component,
  org = false,
  exact = true,
  admin = false,
  orgAdmin = false,
}) => {
  const condition =
    admin || org || orgAdmin
      ? GetStorage("optime_token")
      : GetStorage("check_user_tenant_token") || GetStorage("optime_token");

  if (admin || org || orgAdmin) {
    RemoveStorage("check_user_tenant_token");
  }

  return condition ? (
    <Route path={path} exact={exact} component={component} />
  ) : admin ? (
    <Redirect to="/optime-admin/couper-atmin/login" />
  ) : org ? (
    <Redirect to="/organization-manager/login" />
  ) : orgAdmin ? (
    <Redirect to="/optime-admin/organization-admin/login" />
  ) : (
    <Redirect to="/login" />
  );
};
export default PrivateRoute;
